import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vueaxios from "vue-axios";
import axios from "axios";

import "@/assets/css/app.css";

router.beforeEach((to, from, next) => {
  const jwt = store.state.member.jwt;
  document.title = "木生婦幼診所";
  if (jwt) {
    store.dispatch("from", from.path);
    next();
  } else {
    if (
      to.path !== "/" &&
      to.path !== "/Testing" &&
      to.path !== "/devx" &&
      to.path.match(/\b\/develop|web|line|ios|android|musoon|pad\/\b/g) === null
    ) {
      //musoon: 院內PC連線, pad: 院內平板
      next("/");
    } else {
      next();
    }
  }
});

//components
import Loading from "@/components/Loading.vue";
import Modal from "@/components/Modal.vue";
import Confirm from "@/components/Confirm.vue";
import Debug from "@/components/Debug.vue";
import Banner from "@/components/Banner.vue";

createApp(App)
  .use(store)
  .use(router)
  .use(vueaxios, axios)
  .component("loading", Loading)
  .component("modal", Modal)
  .component("Confirm", Confirm)
  .component("debug", Debug)
  .component("banner", Banner)
  .mount("#app");
